import React from 'react'
import { Select, Input, Form, Button, Divider, message, Tabs, Anchor, Spin, Pagination, Tooltip, DatePicker, Steps } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import {getParmUrl} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './medical-equipmentn-onhaitao.module.less'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
const { TextArea } = Input
class RegistrationCertificateInformation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      medicalCareOnHtaoData: null
    }
  }

  componentDidMount () {
    this.setState({
      medicalCareOnHtaoData: JSON.parse(sessionStorage.getItem('medicalCareOnHtaoData'))
    }, () => {
    })
  }

  // 获取输入框的值
  handleChangeInput=(e, name) => {
    let {medicalCareOnHtaoData} = this.state
    medicalCareOnHtaoData.item_info[name] = e.target.value
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // 下一步
  handleNext=() => {
    let {medicalCareOnHtaoData} = this.state
    sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(medicalCareOnHtaoData))
    this.props.getCurrent(2)
  }

  //  上一步
  handleBack =() => {
    let {medicalCareOnHtaoData} = this.state
    sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(medicalCareOnHtaoData))
    this.props.getCurrent(0)
  }

  render () {
    let {medicalCareOnHtaoData} = this.state
    return (
      <div>
        <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
          <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', paddingLeft: '13%' }}>
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>产品注册证号：</span>
                <Input onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.regist_number : ''} placeholder='请输入' name='regist_number' onChange={(e) => this.handleChangeInput(e, 'regist_number')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>规格型号：</span>
                <Input onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.spec_type : ''} placeholder='请输入' name='spec_type' onChange={(e) => this.handleChangeInput(e, 'spec_type')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>成分：</span>
                <Input onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.element : ''} placeholder='请输入' name='element' onChange={(e) => this.handleChangeInput(e, 'element')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>注册证有效期：</span>
                <Input onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.regist_useful_life : ''} placeholder='请输入' name='regist_useful_life' onChange={(e) => this.handleChangeInput(e, 'regist_useful_life')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>生产企业：</span>
                <Input onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.create_company : ''} placeholder='请输入' name='create_company' onChange={(e) => this.handleChangeInput(e, 'create_company')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>产地：</span>
                <Input onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.origin_place : ''} placeholder='请输入' name='origin_place' onChange={(e) => this.handleChangeInput(e, 'origin_place')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection} style={{display: 'flex'}}>
                <div>
                  <span className={styles.publlictitle}><span className={styles.required}>*</span>主要功能：</span>
                </div>
                <div>
                  <TextArea onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.main_function : ''} rows={7} placeholder='请输入' name='main_function' onChange={(e) => this.handleChangeInput(e, 'main_function')} style={{ width: 244, marginRight: '0px' }} />
                </div>
              </section><br/>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>存储要求：</span>
                <Input onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.storage_request : ''} placeholder='请输入' name='storage_request' onChange={(e) => this.handleChangeInput(e, 'storage_request')} style={{ width: 244, marginRight: '0px' }} />
              </section>
            </div>

            <div style={{width: '100%', marginBottom: '24px', marginTop: '56px', textAlign: 'center'}}>
              <Button type='' shape="round" onClick={this.handleBack}>上一步</Button>
              <Button type='' shape="round" style={{margin: '0px 8px'}} onClick={this.handleNext}>下一步</Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default RegistrationCertificateInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addcompleteinformation/medicalequipmentnonhaitao/registration-certificate-information.js